/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DropdownUsers_allUsers$ref: FragmentReference;
declare export opaque type DropdownUsers_allUsers$fragmentType: DropdownUsers_allUsers$ref;
export type DropdownUsers_allUsers = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +username: string,
      +firstName: string,
      +lastName: string,
    |}
  |}>,
  +$refType: DropdownUsers_allUsers$ref,
|};
export type DropdownUsers_allUsers$data = DropdownUsers_allUsers;
export type DropdownUsers_allUsers$key = {
  +$data?: DropdownUsers_allUsers$data,
  +$fragmentRefs: DropdownUsers_allUsers$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DropdownUsers_allUsers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = 'dd68882840d06ec039c165cec0c49868';

module.exports = node;
